import React from "react";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { useGetMeQuery } from "../../store/slices/accessApi";
import { Screen, Message } from "./AuthGate.styles";

// Показывает приложение только вошедшему пользователю. Без сессии сервер отвечает 401,
// и baseQuery уводит на вход через ComradeMajor.
const AuthGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { data: user, error, refetch } = useGetMeQuery();

  if (user) return <>{children}</>;

  const status = error && "status" in error ? error.status : undefined;

  if (!error || status === 401) {
    return (
      <Screen>
        <ProgressSpinner style={{ width: "48px", height: "48px" }} />
        {status === 401 && <Message>Переход на страницу входа…</Message>}
      </Screen>
    );
  }

  return (
    <Screen>
      <Message>Не удалось связаться с сервером</Message>
      <Button label="Повторить" icon="pi pi-refresh" onClick={() => refetch()} />
    </Screen>
  );
};

export default AuthGate;
